import { appointmentTypeColor } from 'Data/format.js'

export function getColor(templates, appointment_type_id) {
  let appointment_type = templates.find(item => item.id === appointment_type_id)
  return appointmentTypeColor(appointment_type?.color_id_computed)
}

export function getAppointmentTypeText(appointment_type_name) {
  return appointment_type_name || 'Select appointment type'
}
